import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_c59156f3__ from "../lib/SIcon.mjs";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__ from "class-variance-authority";
const inputVariants = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)("appearance-none w-full px-3 !text-[13px] transition-all outline-none", {
    variants: {
        variant: {
            default: "bg-grayscale-dark h-[32px] rounded-md border border-input focus:border-white/30 focus:ring-0",
            borderless: "border-none focus:border-none focus:ring-0 bg-transparent"
        },
        state: {
            disabled: "text-white/50 cursor-not-allowed"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
const Input = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(({ className, borderless = false, styleless, iconType, variant, state, ...props }, ref)=>{
    if (borderless) variant = "borderless";
    if (props.disabled) state = "disabled";
    const input = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("input", {
        ref: ref,
        ...props,
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(styleless ? className : inputVariants({
            variant,
            state,
            className
        }))
    });
    return iconType ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: "relative w-full",
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("input", {
                ref: ref,
                ...props,
                className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(inputVariants({
                    variant,
                    state
                }), className, "!pr-10")
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: "absolute right-[9px] z-10 top-[9px] bottom-[9px] transform flex flex-row items-center justify-center pl-[9px] border-l border-white/10",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_c59156f3__.SIcon, {
                    size: 12,
                    className: "opacity-50",
                    type: iconType
                })
            })
        ]
    }) : input;
});
export { Input, inputVariants };
